// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__3gi6p","nonWrappingTooltip":"Tooltip_nonWrappingTooltip__3E3yL"};